import { useStores } from "@hooks/stores";
import { isNonExpandActionClick } from "@utils";
import { useCallback, useState } from "react";

export const useTableExpandHandler = ({
  expandable,
  isOpened,
  isEmpty,
  onExpand,
  onEmptyExpand,
}) => {
  const { stateStore } = useStores();
  
  const [ isExpanding, setIsExpanding ] = useState(false);
  // const isExpanding = useRef(false);
  
  const handleOpen = useCallback((event) => {
    if (isExpanding.current || isNonExpandActionClick(event))
      return;
    
    if(isEmpty && onEmptyExpand) {
      onEmptyExpand(event);
      return;
    }
    
    if (!expandable)
      return;
    
    onExpand(!isOpened);
  }, [ expandable, isEmpty, isOpened, onExpand, onEmptyExpand ]);
  
  const onExit = useCallback((targetCollapse) => {
    setIsExpanding(true);
    const container = targetCollapse.closest("div[role='rowgroup']");
    const row = container?.firstChild;
    if(container && row)
      stateStore.setScrollRefPadding(container.clientHeight - row.clientHeight);
  }, []);
  
  const onExited = useCallback(() => {
    setIsExpanding(false);
  }, []);
  
  const onEnter = useCallback(() => {
    setIsExpanding(true);
  }, []);
  
  const onEntered = useCallback((targetCollapse) => {
    const container = targetCollapse.closest("div[role='rowgroup']");
    const row = container?.firstChild;
    if(container && row)
      stateStore.updateScrollRefPadding();
    
    setIsExpanding(false);
  }, []);
  
  return {
    // isExpanding,
    handleOpen,
    onExit,
    onExited,
    onEnter,
    onEntered,
  };
}